// クリックデモ用の「LINE → LINE内ブラウザ(LIFF)で打刻ページ」動線（バックエンド・実LINE非接続）。
// installDemo.js の「LINEを開く」から呼ばれる。実物は LINE のリッチメニュー→LINE内ブラウザで
// LIFF ページ(templates/liff/punch.html)が開く構造。それが伝わるよう、
//   ①LINE画面(緑ヘッダ＋リッチメニュー) → ②[完全遷移] → ③ブラウザ風ヘッダ(URL表示)＋打刻ページ
// の2スクリーンをスライド遷移で分ける（＝打刻はLINE内蔵ではなく別のWebページだと分かる）。
// 状態更新は demoServer の clockIn/clockOut を使い、閉じると onDone()（＝ホーム再読込）で反映する。
import { isWorking, clockIn, clockOut } from "./demoServer";

const GREEN = "#06C755"; // LINE ブランドグリーン
const FONT = "system-ui,'Noto Sans JP',sans-serif";
const OFFICE = { name: "本社スタジオ", radius: 100 };
const DOMAIN = "admin.dance-slash.com"; // LINE内ブラウザのアドレスバー表示（実LIFFの配信元）

function el(tag, style, text) {
  const e = document.createElement(tag);
  if (style) e.style.cssText = style;
  // 罠回避: index.css の `span,button,label,a…{color:var(--text)!important}` に飲まれて
  // ラベルが薄消えするため、指定した color をインライン !important で焼き込む。
  if (e.style.color) e.style.setProperty("color", e.style.color, "important");
  if (text != null) e.textContent = text;
  return e;
}
function icon(paths, stroke, size) {
  const span = document.createElement("span");
  span.style.cssText = "display:inline-flex";
  span.innerHTML = `<svg viewBox="0 0 24 24" width="${size || 24}" height="${size || 24}" fill="none" stroke="${stroke}" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">${paths}</svg>`;
  return span;
}
const ICON = {
  in: '<path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><path d="M10 17l5-5-5-5"/><path d="M15 12H3"/>',
  out: '<path d="M9 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4"/><path d="M16 17l5-5-5-5"/><path d="M21 12H9"/>',
  home: '<path d="M3 10.5 12 4l9 6.5"/><path d="M5 9.5V20h14V9.5"/><path d="M10 20v-5h4v5"/>',
  pin: '<path d="M12 21s7-5.6 7-11a7 7 0 1 0-14 0c0 5.4 7 11 7 11z"/><circle cx="12" cy="10" r="2.4"/>',
  lock: '<rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/>',
};
function pad(n) { return String(n).padStart(2, "0"); }
function nowHM() { const d = new Date(); return `${pad(d.getHours())}:${pad(d.getMinutes())}`; }
function todayJa() { const d = new Date(); const w = ["日", "月", "火", "水", "木", "金", "土"]; return `${d.getMonth() + 1}月${d.getDate()}日(${w[d.getDay()]})`; }
function sleep(ms) { return new Promise((r) => setTimeout(r, ms)); }

export function openLineDemo(onDone) {
  const onKey = (e) => { if (e.key === "Escape") close(); };
  const close = () => { back.remove(); document.removeEventListener("keydown", onKey); };
  const finish = () => { close(); if (onDone) onDone(); };

  const back = el("div", `position:fixed;inset:0;z-index:99999;background:rgba(24,25,27,.55);display:flex;align-items:center;justify-content:center;padding:16px;font-family:${FONT}`);
  back.onclick = (e) => { if (e.target === back) close(); };
  const phone = el("div", "position:relative;background:#e9edf1;width:min(400px,94vw);height:min(760px,90vh);border-radius:22px;overflow:hidden;box-shadow:0 24px 60px -20px rgba(0,0,0,.5)");
  back.append(phone);
  (document.body || document.documentElement).appendChild(back);

  // ── スクリーン①：LINEアプリ画面（緑ヘッダ＋トーク＋リッチメニュー） ──
  const lineScreen = el("div", "position:absolute;inset:0;display:flex;flex-direction:column;background:#e9edf1;transition:transform .28s ease");
  const head = el("div", `flex:0 0 auto;height:54px;background:${GREEN};display:flex;align-items:center;gap:8px;padding:0 10px`);
  const closeX = el("button", "background:none;border:none;color:#fff;font-size:24px;line-height:1;cursor:pointer;padding:2px 8px", "×");
  closeX.onclick = close;
  head.append(closeX, el("div", "font-size:16px;font-weight:700;color:#fff", "Guluu スタッフ"),
    el("span", "margin-left:auto;font-size:10px;font-weight:700;letter-spacing:.06em;background:rgba(255,255,255,.22);color:#fff;padding:3px 7px;border-radius:6px", "DEMO"));

  function buildLine() {
    const working = isWorking();
    // トーク
    const chat = el("div", "flex:1;overflow-y:auto;padding:16px 14px");
    const row = el("div", "display:flex;gap:8px;align-items:flex-start;max-width:90%");
    row.append(el("div", `flex:0 0 auto;width:34px;height:34px;border-radius:50%;background:${GREEN};color:#fff;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:13px`, "G"));
    const bw = el("div", "");
    bw.append(el("div", "font-size:11px;color:#7a8290;margin:0 0 3px 2px", "Guluu スタッフ"));
    bw.append(el("div", "background:#fff;border-radius:4px 14px 14px 14px;padding:10px 13px;font-size:13.5px;line-height:1.65;color:#18191b;box-shadow:0 1px 1px rgba(0,0,0,.06)",
      working ? "現在は勤務中です。退勤するときは下のメニューから「退勤」を押してください。"
        : "おはようございます。下のメニューから「出勤」を押して打刻してください。"));
    row.append(bw);
    chat.append(row);
    // リッチメニュー
    const menu = el("div", "flex:0 0 auto;background:#fff;border-top:1px solid rgba(18,20,24,.08);padding:9px 9px 12px");
    menu.append(el("div", "width:36px;height:4px;border-radius:2px;background:#d6dae0;margin:0 auto 9px"));
    const grid = el("div", "display:grid;grid-template-columns:1fr 1fr;gap:8px");
    grid.append(
      tile("出勤", ICON.in, GREEN, !working, () => openBrowser("in")),
      tile("退勤", ICON.out, "#b3261e", working, () => openBrowser("out")),
    );
    const my = tile("マイページを開く", ICON.home, "#3b5bdb", false, close, true);
    my.style.gridColumn = "1 / -1";
    grid.append(my);
    menu.append(grid);
    return [chat, menu];
  }
  lineScreen.append(head, ...buildLine());
  phone.append(lineScreen);

  function tile(label, paths, color, highlight, onClick, light) {
    const bg = light ? "#f4f6f8" : color;
    const fg = light ? "#3b5bdb" : "#fff";
    const b = el("button", `display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;padding:16px 6px;border:none;border-radius:12px;cursor:pointer;background:${bg};color:${fg};opacity:${highlight || light ? 1 : 0.55}`);
    b.append(icon(paths, fg), el("span", `font-size:13.5px;font-weight:700;color:${fg}`, label));
    b.onclick = onClick;
    return b;
  }

  // ── スクリーン②：LINE内ブラウザ（アドレスバー付き）で開く打刻ページ ──
  // 右からスライドインし、①は少し左へ退避＝「別のWebページに完全遷移」を表現。
  function openBrowser(kind) {
    const scr = el("div", "position:absolute;inset:0;display:flex;flex-direction:column;background:#fff;transform:translateX(100%);transition:transform .28s ease;z-index:2");
    // ブラウザ風ヘッダ（LINE内ブラウザ相当）
    const bar = el("div", "flex:0 0 auto;background:#f7f8fa;border-bottom:1px solid rgba(18,20,24,.1)");
    const barTop = el("div", "height:50px;display:flex;align-items:center;gap:6px;padding:0 8px");
    const x = el("button", "background:none;border:none;font-size:19px;cursor:pointer;color:#18191b;padding:2px 8px;line-height:1", "✕");
    x.onclick = () => closeBrowser(scr);
    const center = el("div", "flex:1;min-width:0;text-align:center");
    center.append(el("div", "font-size:13.5px;font-weight:700;color:#18191b;white-space:nowrap;overflow:hidden;text-overflow:ellipsis", "勤怠打刻"));
    const dom = el("div", "display:flex;align-items:center;justify-content:center;gap:4px;margin-top:1px");
    dom.append(icon(ICON.lock, "#83868b", 11), el("span", "font-size:11px;color:#83868b;white-space:nowrap;overflow:hidden;text-overflow:ellipsis", DOMAIN));
    center.append(dom);
    barTop.append(x, center, el("div", "font-size:20px;color:#b6b9be;padding:2px 8px;letter-spacing:1px", "⋯"));
    const load = el("div", `height:2px;background:${GREEN};width:0`);
    bar.append(barTop, load);
    // ページ本体（Webページ＝白背景）
    const body = el("div", "flex:1;overflow-y:auto;padding:22px 18px;background:#fff");
    scr.append(bar, body);
    phone.append(scr);

    // 遷移アニメ＋ページ読み込みバー（「別ページを開いた」感）
    void scr.offsetWidth;
    scr.style.transform = "translateX(0)";
    lineScreen.style.transform = "translateX(-22%)";
    requestAnimationFrame(() => { load.style.transition = "width .5s ease"; load.style.width = "100%"; });
    setTimeout(() => { load.style.transition = "opacity .3s"; load.style.opacity = "0"; }, 640);

    renderPunch(kind, body, scr);
  }
  function closeBrowser(scr) {
    scr.style.transform = "translateX(100%)";
    lineScreen.style.transform = "translateX(0)";
    setTimeout(() => scr.remove(), 300);
  }

  // ── 打刻ページの中身（Webページ本体）。kind: "in" | "out" ──
  async function renderPunch(kind, body, scr) {
    body.textContent = "";
    const working = isWorking();
    body.append(el("div", "font-size:21px;font-weight:800;color:#18191b;text-align:center;margin:2px 0 16px", kind === "in" ? "出勤" : "退勤"));
    const status = el("div", "font-size:14px;color:#5c5f63;text-align:center;min-height:20px;margin-bottom:16px");
    const area = el("div", "");
    body.append(status, area);

    if (kind === "in") {
      if (working) { status.textContent = "既に出勤中です。"; area.append(backToLine()); return; }
      status.textContent = "位置情報を確認中…";
      await sleep(1000);
      if (!scr.isConnected) return; // 途中で閉じられたら中断
      status.textContent = "この内容で出勤しますか？";
      area.append(timeBox("出勤"), modeBox("事務所"), locNote());
      const btn = actionBtn("この内容で出勤する", GREEN);
      btn.onclick = async () => {
        btn.disabled = true; btn.style.opacity = ".6";
        area.textContent = ""; status.textContent = "出勤を記録中…";
        await sleep(650);
        clockIn();
        status.textContent = "";
        area.append(resultBox("出勤しました（事務所）", "#1f6b53"), homeBtn());
      };
      area.append(btn);
    } else {
      if (!working) { status.textContent = "退勤する勤務がありません（未出勤）。"; area.append(backToLine()); return; }
      status.textContent = "日報を入力して退勤してください";
      const ta = el("textarea", "width:100%;box-sizing:border-box;min-height:120px;border:1px solid rgba(18,20,24,.18);border-radius:10px;padding:11px 12px;font-size:14px;line-height:1.6;font-family:inherit;resize:vertical");
      ta.placeholder = "本日の業務内容を入力してください";
      const hint = el("div", "font-size:12px;color:#b3261e;min-height:16px;margin:6px 2px 0");
      const btn = actionBtn("退勤を確定", "#b3261e");
      btn.onclick = async () => {
        const report = ta.value.trim();
        if (!report) { hint.textContent = "日報を入力してください。"; return; }
        hint.textContent = ""; btn.disabled = true; btn.style.opacity = ".6";
        area.textContent = ""; status.textContent = "退勤を記録中…";
        await sleep(650);
        clockOut(report);
        status.textContent = "";
        area.append(resultBox("退勤しました。お疲れさまでした。", "#1f6b53"), homeBtn());
      };
      area.append(ta, hint, btn);
    }

    // ── 打刻ページ内の部品 ──
    function timeBox(label) {
      const box = el("div", "background:#f4f6f8;border-radius:12px;padding:16px;text-align:center;margin-bottom:10px");
      box.append(el("div", "font-size:12px;color:#83868b;margin-bottom:4px", `${label}時刻`),
        el("div", "font-size:30px;font-weight:800;color:#18191b;letter-spacing:.02em", nowHM()),
        el("div", "font-size:12px;color:#83868b;margin-top:2px", todayJa()));
      return box;
    }
    function modeBox(mode) {
      const box = el("div", "display:flex;align-items:center;justify-content:center;gap:8px;margin-bottom:8px");
      box.append(el("span", "font-size:12px;color:#83868b", "勤務形態"),
        el("span", "font-size:13px;font-weight:700;color:#18191b;background:#eceef0;padding:4px 12px;border-radius:999px", mode));
      return box;
    }
    function locNote() {
      const n = el("div", "display:flex;align-items:center;justify-content:center;gap:5px;margin-bottom:18px");
      n.append(icon(ICON.pin, "#83868b", 15), el("span", "font-size:12px;color:#83868b", `${OFFICE.name} ・ 半径${OFFICE.radius}m内`));
      return n;
    }
    function actionBtn(label, color) {
      return el("button", `width:100%;border:none;border-radius:11px;padding:15px;font-size:16px;font-weight:700;color:#fff;background:${color};cursor:pointer`, label);
    }
    function resultBox(text, color) {
      return el("div", `background:#e4efe8;border-radius:12px;padding:16px;text-align:center;font-size:15px;font-weight:700;color:${color};margin-bottom:14px`, text);
    }
    function homeBtn() {
      const b = el("button", "width:100%;border:1px solid rgba(18,20,24,.15);background:#fff;border-radius:11px;padding:13px;font-size:14px;font-weight:700;color:#18191b;cursor:pointer", "ホームで確認する");
      b.onclick = finish;
      return b;
    }
    // 既に出勤中／未出勤で退勤 など「やることが無い」状態は、LINEに戻すより
    // ホームへ戻す方が自然（打刻不要なので確認画面へ）。
    function backToLine() {
      const b = el("button", "width:100%;border:1px solid rgba(18,20,24,.15);background:#fff;border-radius:11px;padding:13px;font-size:14px;font-weight:700;color:#18191b;cursor:pointer;margin-top:8px", "ホームに戻る");
      b.onclick = finish;
      return b;
    }
  }

  document.addEventListener("keydown", onKey);
  return close;
}
